@switch (columnName) {
  @case ('mainContact') {
    @if (element.isMainContact) {
      <mat-icon class="tick">done</mat-icon>
    }
  }
  @case ('fullName') {
    {{ element | fullName }}
  }
  @case ('employedInDepartments') {
    <div>
      <strong>{{ element.employmentDepartment }}</strong>
    </div>
    @for (department of element.accessToDepartments; track department) {
      <div>
        {{ department }}
      </div>
    }
  }
  @case ('phoneNumber') {
    +{{ element.mobilePrefix }} {{ element.mobile }}
  }
  @case ('status') {
    @if (element.deleted) {
      <mat-icon class="red" [matTooltip]="'deletedUserStatus' | translate">cancel</mat-icon>
    } @else {
      @if (element.hasDeletedEmployment) {
        <mat-icon class="red" [matTooltip]="'deletedEmploymentStatus' | translate">block</mat-icon>
      } @else {
        @if (element.hasPausedEmployment) {
          <mat-icon class="cross" [matTooltip]="'pausedEmploymentStatus' | translate">
            pause
          </mat-icon>
        } @else {
          @if (element.isActive) {
            <mat-icon class="tick" [matTooltip]="'activeNotDeletedUserStatus' | translate">
              done
            </mat-icon>
          } @else {
            <mat-icon class="cross" [matTooltip]="'inactiveUserStatus' | translate">close</mat-icon>
          }
        }
      }
    }
  }
  @case ('roles') {
    @for (role of element.roles; track role?.id ?? role?.name ?? role) {
      <div>
        <strong>{{ role.name }}</strong>
        <br />
        @for (
          department of role.issuedForDepartments;
          track department?.id ?? department?.name ?? department;
          let f = $first;
          let l = $last
        ) {
          <span>{{ department.name }}{{ l ? '' : ', ' }}</span>
        }
      </div>
    }
  }
  @case ('edit') {
    <app-ui-button
      buttonType="icon-button"
      icon="edit"
      [ariaLabel]="'edit' | translate"
      (click)="buttonFunctions.edit()"
    ></app-ui-button>
  }
  @case ('delete') {
    <app-ui-button
      buttonType="icon-button"
      icon="delete"
      [ariaLabel]="'delete' | translate"
      appConfirmDialog
      [confirmEntityName]="element | fullName"
      (confirmed)="buttonFunctions.delete()"
    ></app-ui-button>
  }
  @default {
    {{ element[columnName] }}
  }
  <!-- User Competences -->
  @case ('statusCompetenceUser') {
    @if (element.statusType === competenceStatusEnum.Red) {
      <mat-icon class="red">circle</mat-icon>
    }
    @if (element.statusType === competenceStatusEnum.Yellow) {
      <mat-icon class="yellow">circle</mat-icon>
    }
    @if (element.statusType === competenceStatusEnum.Orange) {
      <mat-icon class="orange">circle</mat-icon>
    }
    @if (element.statusType === competenceStatusEnum.Green) {
      <mat-icon class="green">circle</mat-icon>
    }
    @if (element.statusType === competenceStatusEnum.White) {
      <mat-icon class="white">circle</mat-icon>
    }
  }
  @case ('hasAttachments') {
    @if (element.hasAttachments) {
      <mat-icon [attr.aria-label]="'hasAttachments' | translate">attach_file</mat-icon>
    }
  }
  @case ('actionCompetenceUser') {
    <div class="competence-user-action-cell">
      @if (element.formId && element.isRegistrationCompleted) {
        <div (click)="routeToCustomForm(element.userCompetenceId, element.formId)">
          <mat-icon>assignment</mat-icon>
        </div>
      } @else {
        @if (element.isExpiring) {
          <app-ui-button
            buttonType="icon-button"
            icon="calendar_month"
            (click)="toRenewCompetence()"
            [privilege]="competenceActionPrivilege"
            [disabled]="!canManageCompetences"
            [tooltip]="inactiveEmploymentTooltip"
          ></app-ui-button>
        } @else {
          <mat-icon>done</mat-icon>
        }
      }
    </div>
  }
  @case ('competenceCode') {
    {{ element.competenceCode }} {{ element.code }}
  }
  @case ('competenceName') {
    <div class="display-flex align-items-center">
      <div>{{ element.name }} {{ element.competenceName }}</div>
      <app-equivalent-competences-tooltip
        [competence]="element"
      ></app-equivalent-competences-tooltip>
    </div>
  }
  @case ('requirementType') {
    @if (element.requirementType === userCompetenceRequirementType.mandatory) {
      <div>
        {{ 'mandatory' | translate | uppercase }}
      </div>
    }
    @if (element.requirementType === userCompetenceRequirementType.optional) {
      <div>
        {{ 'optional' | translate | uppercase }}
      </div>
    }
    @if (element.requirementType === userCompetenceRequirementType.preferred) {
      <div>
        {{ 'preferred' | translate | uppercase }}
      </div>
    }
    @if (element.requirementType === userCompetenceRequirementType.notRequired) {
      <div>
        {{ 'notRequired' | translate | uppercase }}
      </div>
    }
  }
  @case ('expiry') {
    @if (element.expiresAt) {
      <div>
        {{ element.expiresAt | date }}
      </div>
    } @else {
      <div>-</div>
    }
  }
  @case ('daysUntilExpired') {
    @if (element.daysUntilExpired) {
      <div class="center">
        {{ element.daysUntilExpired }}
      </div>
    } @else {
      <div>-</div>
    }
  }
  @case ('selfAssignable') {
    <mat-icon class="material-icons-round">
      {{ element.selfAssignable ? 'check' : 'close' }}
    </mat-icon>
  }
  @case ('registrationComplete') {
    @if (element.isRegistrationCompleted === true) {
      <div class="center">
        {{ 'yes' | translate }}
      </div>
    }
    @if (element.isRegistrationCompleted === false) {
      <div class="center">
        {{ 'no' | translate }}
      </div>
    }
  }
}
